import { createAction, createSlice, } from "@reduxjs/toolkit";
const initialState = {
	loading: true,
	error: "",
	profileDetails: (JSON.parse(localStorage.getItem('profile')) || {}),
};

export const profileSlice = createSlice({
	name: "profile",
	initialState,
	reducers: {
		setIsLoading(state, action) {
			state.loading = action.payload;
		},
		setProfile(state, action) {
			let data = action.payload;
			state.profileDetails = data;
			state.loading = false;
		},
		updateProfile(state, action) {
			state.profileDetails = {
				...state.profileDetails,
				...(action?.payload?.body || {}),
			};
		},
	}
});

export const profileActions = {
	loadProfile: createAction(`${profileSlice.name}/loadProfile`, (payload) => ({ payload })),
	setProfile: profileSlice.actions.setProfile,
	changeProfile: createAction(`${profileSlice.name}/changeProfile`, (payload) => ({ payload })),
	updateProfile: profileSlice.actions.updateProfile,
};
export const getProfile = (state) => state.profile.profileDetails;

export default profileSlice.reducer;
